export const performTracksList = (player, component) => {
  const availableTracks = player.getComponents(component);

  if (availableTracks.length) {
    const activeRawComponent = player.getCurrentActiveComponents(component);
    const activeTrackPid = activeRawComponent.length ? activeRawComponent[0].pid : null;
    const result = [];
    for (let i = 0; i < availableTracks.length; i += 1) {
      const track = availableTracks[i];
      let roles = ['main'];
      let { language } = track;

      if (component === player.COMPONENT_TYPE_SUBTITLE) {
        roles = ['subtitle'];
        language = language.split(':')[0];
        // TODO define how to detect CC
      }

      if (language && language.length) {
        language =
          component === player.COMPONENT_TYPE_AUDIO
            ? language.toLowerCase().split('-')[0]
            : language.toLowerCase().substring(0, 2);
      }

      result.push({
        active: track.pid === activeTrackPid,
        language,
        roles,
        id: track.pid,
        raw: track,
      });
    }

    return result.sort((a, b) => a.id < b.id);
  }

  return [];
};

export const makeSourceURL = (reference, token, drmSettings) => {
  const drmServerURL = drmSettings['com.microsoft.playready'].serverURL;
  const customData = btoa(
    JSON.stringify({
      userId: token.uid,
      sessionId: drmSettings.sessionId,
      merchant: drmSettings.merchantId,
      authToken: token.value,
    }),
  );

  return `${reference}&custom_data=${customData}&la_url=${drmServerURL}`;
};
